export const classConstants = {

    FETCH_CLASSES_REQUEST: 'FETCH_CLASSES_REQUEST',
    FETCH_CLASSES_SUCCESS: 'FETCH_CLASSES_SUCCESS',
    FETCH_CLASSES_FAILURE: 'FETCH_CLASSES_FAILURE',

    CREATE_CLASS_REQUEST: 'CREATE_CLASS_REQUEST',
    CREATE_CLASS_SUCCESS: 'CREATE_CLASS_SUCCESS',
    CREATE_CLASS_FAILURE: 'CREATE_CLASS_FAILURE',

    UPDATE_CLASS_REQUEST: 'UPDATE_CLASS_REQUEST',
    UPDATE_CLASS_SUCCESS: 'UPDATE_CLASS_SUCCESS',
    UPDATE_CLASS_FAILURE: 'UPDATE_CLASS_FAILURE',

    DELETE_CLASS_REQUEST: 'DELETE_CLASS_REQUEST',
    DELETE_CLASS_SUCCESS: 'DELETE_CLASS_SUCCESS',
    DELETE_CLASS_FAILURE: 'DELETE_CLASS_FAILURE',

    CLEAR_CHATHISTORY_REQUEST: 'CLEAR_CHATHISTORY_REQUEST',
    CLEAR_CHATHISTORY_SUCCESS: 'CLEAR_CHATHISTORY_SUCCESS',
    CLEAR_CHATHISTORY_FAILURE: 'CLEAR_CHATHISTORY_FAILURE',

    ACTIVATE_CLASS_REQUEST: 'ACTIVATE_CLASS_REQUEST',
    ACTIVATE_CLASS_SUCCESS: 'ACTIVATE_CLASS_SUCCESS',
    ACTIVATE_CLASS_FAILURE: 'ACTIVATE_CLASS_FAILURE',

}